import { Pipe, PipeTransform } from '@angular/core';
import { digitsEnToFa } from '@persian-tools/persian-tools';

@Pipe({ name: 'digitsEnToFa' })
export class DigitsEnToFa implements PipeTransform {
  transform(value: string | number | null | undefined, exponent = 1): string {
    if (typeof value !== 'number' && !value) return 'NULL_VAL';

    value = value.toString() || '';
    const enDigits = digitsEnToFa(value);
    return enDigits;
  }
}
